import { Donvi } from '../quanlythongtin/donvi';
import { Coquanbanhanh } from './coquanbanhanh';
import { Nguoiky } from './nguoiky';

export class Diendancutri {
  id: number;
  hoten: string;
  diachi: string;
  email: string;
  sodienthoai: string;
  cauhoi: string;
  noidung: string;
  taptin: string;
  duyet: number;
  sovanban: string;
  ngayvanban: Date;
  noidungtraloi: string;
  taptintl: string;  
  isactive: number;
  createddate: Date;
  createdbyuserid: number;
  modifieddate: Date;
  modifiedbyuserid: number;  
  dmdonvi: Donvi;
  donviid: number;
  dmnguoiky: Nguoiky;
  nguoikyid: number;
  dmcoquanbanhanh : Coquanbanhanh;
  coquanbanhanhid : number;
  showanswer: boolean = false;
  noidungrutgon: string;
}